import * as React from 'react'
import { useState } from 'react'
import { Box, Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { type PositionsFilter } from 'pages'
import ButtonWithIcon from '../../common/button-with-icon'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import { type PositionType } from 'services'
import PositionTypeSelector from './position-type'

export interface PositionFiltersProps {
  filters: PositionsFilter
  updateFilters: (filters: any) => Promise<void>
  doFilter: () => Promise<void>
  cleanFilters: () => void
}

export const PositionFilters: React.FC<PositionFiltersProps> = ({ filters, updateFilters, doFilter, cleanFilters }) => {
  const [disabledNames, setDisabledNames] = useState(false)

  const handlerClean = (): void => {
    cleanFilters()
    setDisabledNames(false)
  }
  const handleTypePositionSelection = (value: PositionType[]): void => {
    if (value.length === 0) {
      void updateFilters({ positionTypes: [] })
      return
    }
    void updateFilters({ positionTypes: value })
  }

  return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2, mt: -3 }}>
            <Card sx={{ flex: 1, p: 1.5, borderRadius: 4 }}>
                <CardContent>
                    <Grid container spacing={2} alignItems='center'>
                        <Grid item xs={2}>
                            <FormControl fullWidth={true} variant="outlined">
                                <TextField
                                    label="Title"
                                    value={filters.title}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { void updateFilters({ title: e.target.value }) }}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                        <PositionTypeSelector handlePositionTypeChange={handleTypePositionSelection} selectedTypes={filters.positionTypes} />
                        </Grid>
                        <Grid item xs={1}>
                            <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Status</InputLabel>
                            <Select
                                value={filters.vacant}
                                label="Status"
                                onChange={event => {
                                  let emptyNames
                                  if (event.target.value === 'vacant') {
                                    setDisabledNames(true)
                                    emptyNames = { firstName: '', lastName: '' }
                                  } else {
                                    setDisabledNames(false)
                                  }

                                  void updateFilters({ vacant: event.target.value, ...emptyNames })
                                }}
                            >
                                <MenuItem value={' '}>Any</MenuItem>
                                <MenuItem value={'vacant'}>Vacant</MenuItem>
                                <MenuItem value={'Occupied'}>Occupied</MenuItem>
                            </Select>
                                </FormControl>
                                </Grid>
                        <Grid item xs={2}>
                            <FormControl fullWidth={true} variant="outlined">
                                <TextField
                                    label="First Name"
                                    disabled={disabledNames}
                                    value={filters.firstName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { void updateFilters({ firstName: e.target.value }) }}
                                    variant="outlined"
                                />
                            </FormControl>
                            </Grid>
                        <Grid item xs={2}>
                            <FormControl fullWidth={true} variant="outlined">
                                <TextField
                                    label="Last Name"
                                    disabled={disabledNames}
                                    value={filters.lastName}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { void updateFilters({ lastName: e.target.value }) }}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControl fullWidth={true} variant="outlined">
                                <TextField
                                    label="Email"
                                    disabled={disabledNames}
                                    value={filters.email}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { void updateFilters({ email: e.target.value }) }}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={10} />
                        <Grid item xs={1}>
                            <ButtonWithIcon fullWidth={true} variant="contained" size='large' nameButton='Search' icon={<FilterAltIcon />} onClick={() => { void doFilter() }}></ButtonWithIcon>
                        </Grid>
                        <Grid item xs={1}>
                            <ButtonWithIcon fullWidth={true} variant="contained" size='large' nameButton='Clean' icon={<CleaningServicesIcon />} onClick={handlerClean}></ButtonWithIcon>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
  )
}
